import React from 'react';

const DemoRequestIcon = () => {
  return (
    <svg
      width='15'
      height='15'
      viewBox='0 0 15 15'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M5.16667 5.16867C5.16631 5.05036 5.19744 4.93408 5.25687 4.83178C5.3163 4.72948 5.40189 4.64483 5.50484 4.58654C5.60779 4.52824 5.7244 4.49839 5.8427 4.50005C5.961 4.50172 6.07673 4.53483 6.178 4.596L9.50933 6.594C9.60851 6.65311 9.69063 6.73696 9.74767 6.83735C9.8047 6.93773 9.83468 7.05121 9.83468 7.16667C9.83468 7.28212 9.8047 7.3956 9.74767 7.49598C9.69063 7.59637 9.60851 7.68022 9.50933 7.73933L6.178 9.73733C6.07668 9.79853 5.96089 9.83165 5.84253 9.83328C5.72418 9.83492 5.60752 9.80501 5.50455 9.74663C5.40157 9.68826 5.316 9.60352 5.25662 9.50112C5.19724 9.39873 5.16619 9.28237 5.16667 9.164V5.16867Z'
        stroke='black'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M7.16667 13.8333C10.8486 13.8333 13.8333 10.8486 13.8333 7.16667C13.8333 3.48477 10.8486 0.5 7.16667 0.5C3.48477 0.5 0.5 3.48477 0.5 7.16667C0.5 10.8486 3.48477 13.8333 7.16667 13.8333Z'
        stroke='black'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
};

export default DemoRequestIcon;
